import HierarchicalDialogPlayer from "../../../../../../lib/html5-software-library/src/ranj/eng/dialog/framework/player/HierarchicalDialogPlayer";
import PlayMode from "../../../../../../lib/html5-software-library/src/ranj/eng/dialog/framework/player/PlayMode";
import AppDefaultDialogPlayer from "./AppDefaultDialogPlayer";

export default class AppHierarchicalDialogPlayer extends HierarchicalDialogPlayer {
    constructor(dialogFactory, timeTickInterval, maxDepth) {
        super(dialogFactory, timeTickInterval, maxDepth);

        this._dialogPlayers = [];
        for (let i = 0; i < this._maxDepth; i++) {
            const nwPlayer = new AppDefaultDialogPlayer(timeTickInterval);
            nwPlayer.setPlayMode(PlayMode.COMMANDS);
            this._dialogPlayers.push(nwPlayer);
        }

    }
}
